import { NgModule } from '@angular/core';
import { MagicStringComponent } from './magic-string.component';

@NgModule({
  declarations: [MagicStringComponent],
  imports: [
  ],
  exports: [MagicStringComponent]
})
export class MagicStringModule { }
